import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ComingSoonPage = lazy(() => import('@/pages/ComingSoonPage'));

/**
 * Placeholder registrations for legacy pages not yet ported, so the complete
 * navigation tree (see `@/config/navigation`) resolves to a friendly
 * "coming soon" page instead of incorrectly 404ing / bouncing home.
 *
 * Currently EMPTY — every legacy page has a real route. Kept as the mechanism
 * for future gaps: add the path here, and when porting the page, DELETE it
 * again and add a real route group file next to this one (see `dashboard.ts`
 * for the shape). Permissions stay in `@/config/auth/routeAccess` — RouteGuard
 * already enforces them for these paths.
 */
const COMING_SOON_PATHS: readonly string[] = [];

export const comingSoonRoutes: RouteConfig[] = COMING_SOON_PATHS.map((path) => ({
  path,
  layout: DashboardLayout,
  element: ComingSoonPage,
}));
